import styles from './index.module.sass';

export const CustomSwitch = ({
  options,
  onClick,
  activeItemIdx,
}: {
  options: { value: string; label?: string; enabled: boolean, id: number }[];
  onClick: (item: any) => void;
  activeItemIdx: number;
}) => {
  return (
    <div className={styles.root}>
      {options.map((item, i) => (
        <div className={styles.option} style={{ color: activeItemIdx === i ? '#fff' : '#7E89A5' }} onClick={() => onClick(item)}>{item.label || item.value}</div>
      ))}
      <div className={styles.shadow} style={{ left: activeItemIdx > 0 ? `${activeItemIdx * (100 / options.length)}%` : '0%'  }}></div>
    </div>
  );
};
